import { Dispatch, SetStateAction, useState } from "react";

import * as Yup from "yup";
import { add } from "date-fns";
import api from "./../../api/api";
import { RentalPrice } from "../../api/types";
import { SelectOption } from "../ui/Select";
import { SendGoogleEvent } from "../../utils/tracking";

const useConnect = (
  setPrices: Dispatch<SetStateAction<RentalPrice[]>>,
  setOffer: Dispatch<SetStateAction<RentalPrice | undefined>>,
  pickupPlace: SelectOption | undefined,
  setPickupPlace: Dispatch<SetStateAction<SelectOption | undefined>>,
  rentalDates: Date[] | undefined,
  setRentalDates: Dispatch<SetStateAction<Date[] | undefined>>
) => {
  const [noResultsFound, setNoResultsFound] = useState(false);

  const validationSchema = Yup.object().shape({
    pickupPlace: Yup.object().shape({
      name: Yup.string().required(),
      value: Yup.string().required(),
    }),
    pickupDate: Yup.date().required("Campo obligatorio"),
    dropoffDate: Yup.date()
      .required("Campo obligatorio")
      .min(Yup.ref("pickupDate")),
  });

  const initialValues = {
    pickupPlace: pickupPlace ?? {
      value: "PHAV16",
      name: "Aeropuerto de La Habana Terminal 2",
    },
    pickupDate: rentalDates?.[0] ?? add(new Date(), { days: 15 }),
    dropoffDate: rentalDates?.[1] ?? add(new Date(), { days: 21 }),
  };

  const onSubmit = async (values: typeof initialValues) => {
    setNoResultsFound(false);
    setPrices([]);
    setOffer(undefined);
    setPickupPlace(values.pickupPlace);
    setRentalDates([values.pickupDate, values.dropoffDate]);

    const prices = await api.getRentalPrices(
      values.pickupPlace.value,
      values.pickupDate,
      values.dropoffDate
    );

    if (prices.data.length === 0) {
      setNoResultsFound(true);
      setPrices([]);
    } else {
      setPrices(prices.data);
    }

    SendGoogleEvent('car_rental_price_search');
  };

  return {
    noResultsFound,
    validationSchema,
    initialValues,
    onSubmit,
  };
};

export default useConnect;
